import { AdditionalInfo, LabeledComponent } from '@commonClient2/components';

import EmployeeInfoContent from './EmployeeInfoContent';

/**
 * Tooltip component with the EE info, displaying some rules and other information
 * just like his/her rank.
 * @param {{
 *  employeeBidProfile: EmployeeBidProfile.IDetailedEmployeeBidProfile;
 * }} param0
 */
const EmployeeInfoDesktop = ({ employeeBidProfile }) => (
    <AdditionalInfo
        className="additionalInfo"
        placement="leftStart"
    >
        <LabeledComponent
            name=""
            className="info-icon"
        >
            <EmployeeInfoContent employeeBidProfile={employeeBidProfile} />
        </LabeledComponent>
    </AdditionalInfo>
);

export default EmployeeInfoDesktop;
